module.exports = __webpack_public_path__ + "static/diy_recipe_crocodile_cookies-d7c27cf80a1931f9c7f17d50c7585ffa.pdf";